import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Select, Input, InputGroup, Help } from 'module-tsl-ui-elements';
import { setup as setupMz, emitPageView } from '../../modules/Mz';
import {
  getMoreDownloads,
  setDownloadsKeywordFilter,
  setDownloadsLicenceFilter,
} from '../../modules/DownloadsModule';

import BaseComponent from './BaseComponent';
import HeaderNav from './HeaderNav';
import DownloadRow from './DownloadRow';

const filterOptions = {
  licence: [
    { label: 'All', value: 'all' },
    { label: 'Free', value: 'free' },
    { label: 'Paid', value: 'paid' },
  ],
};

@connect(
  state => ({
    keywordFilter: state.downloadsModule.downloadsKeywordFilter,
    licenceFilter: state.downloadsModule.downloadsLicenceFilter,
  }),
  {
    setKeywordFilter: setDownloadsKeywordFilter,
    setLicenceFilter: setDownloadsLicenceFilter,
  },
)

class DownloadsFilter extends Component {
  render() {
    return (
      <div>
        <Help emphasised>
          <p>
            Please remember to download your resources.
          </p>
          <p>
          Tes cannot guarantee that a resource will remain on the platform indefinitely, please ensure that you download and store any resources you wish to keep on your device.
          Tes will not be responsible for, nor reimburse you if you lose access to content previously purchased.
          </p>
        </Help>
        <div className="user-dashboard-filter user-dashboard-filter-downloads">
          <div className="row">
            <div className="col-sm-6 licence-filter">
              <Select
                id="licenceFilter"
                options={filterOptions.licence}
                onChange={({ target }) => {
                  this.props.setLicenceFilter({ value: target.value, label: filterOptions.licence.find(item => item.value === target.value).label });
                }}
              />
            </div>
            <div className="col-sm-6 text-right-screen-sm text-filter">
              <InputGroup
                self={{ groupId: 'keyword-filter' }}
                customInput={
                  <Input
                    id="keyword-filter-input"
                    value={this.props.keywordFilter}
                    onChange={e => this.props.setKeywordFilter(e.target.value)}
                    placeholder="Filter by resource title"
                    icon={<i className="icon icon--tds-magnifying-glass icon-gray icon--unit-sm" />}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DownloadsFilter.propTypes = {
  licenceFilter: PropTypes.object,
  setLicenceFilter: PropTypes.func,
  setKeywordFilter: PropTypes.func,
  keywordFilter: PropTypes.string,
};

@connect(
  state => ({
    items: state.downloadsModule.downloads,
    loaded: state.downloadsModule.downloadsLoaded,
    allLoaded: state.downloadsModule.downloadsAllLoaded,
    isAuthenticated: state.profileModule.isAuthenticated,
  }),
  { getMoreDownloads, setupMz, emitPageView },
)
export default class Downloads extends BaseComponent {
  componentDidMount() {
    if (this.props.isAuthenticated && this.props.items.length === 0) {
      this.props.getMoreDownloads();
      this.props.setupMz('resource.dash-dl');
    }
    if (typeof window.emitPageView === 'undefined') {
      window.emitPageView = true;
    }
    if (this.props.emitPageView) {
      this.props.emitPageView();
    }
  }

  render() {
    const { loaded, items, allLoaded } = this.props;

    const bodyLoading = (
      <div className="text-center my-2">
        <Button loading>Loading</Button>
      </div>
    );
    const bodyWithItems = this.props.items.map((item, i) => (
      <DownloadRow key={i} resource={item} index={i} />
    ));
    if (!loaded) bodyWithItems.push(bodyLoading);
    const bodyNoItems = loaded ? (
      <div className="dashboard-card__container" key={'no-content'}>
        You don't have any resources to be displayed here.
      </div>
    ) : (
      bodyLoading
    );
    const body = items && items.length ? bodyWithItems : bodyNoItems;
    document.title = 'My Resources dashboard - teaching resources - Tes';
    let showMoreBtn = null;
    if (!allLoaded && loaded) {
      showMoreBtn = (
        <div className="text-center my-2">
          <Button
            theme="secondary"
            onClick={() => this.props.getMoreDownloads()}
          >
            Show more
          </Button>
        </div>
      );
    }
    return (
      <div>
        <div className="container-fluid-max margin-bottom-xl">
          <div className="row">
            <div className="tes-panel">
              <HeaderNav route="" />
              <div className="tes-panel__body tes-panel__body--sm">
                <DownloadsFilter />
                {body}
                {showMoreBtn}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
